import { Table } from '@tanstack/react-table';
import { ComponentProps } from 'react';
import { CheckboxLabeled } from '../../../../../design-system/checkbox/checkbox-labeled';
import { cn } from '../../../../../utils/cn';

type TableFilterSelectAllProps<TData> = Omit<ComponentProps<typeof CheckboxLabeled>, 'checked' | 'label'> & {
  table: Table<TData>;
};

export const TableFilterSelectAll = <TData,>({ table, ...props }: TableFilterSelectAllProps<TData>) => {
  const isAllRowsSelected = table.getIsAllRowsSelected();
  const isSomeRowsSelected = table.getIsSomeRowsSelected();
  const isIndeterminate = isSomeRowsSelected && !isAllRowsSelected;

  return (
    <CheckboxLabeled
      {...props}
      checked={isIndeterminate ? 'indeterminate' : isAllRowsSelected}
      label="Select all"
      labelClassName={cn('text-xs font-medium text-black leading-5 tracking-tight', {
        'text-seapoint-gray-text': props.disabled,
      })}
      onCheckedChange={(value) => {
        table.toggleAllRowsSelected(!!value);
      }}
    />
  );
};
